
export default ({ app, context }, inject) => {
    const timeutil = {
        getNowDatetime: function (){
            return this.timeFormat(new Date());
        },
        getNowDate: function (){
            return this.timeFormat(new Date()).split(' ')[0];
        },
        getPastDayDatetime: function (day){
            let dt = new Date();
            dt.setDate(dt.getDate() - day)
            return this.timeFormat(dt);
        },
        getPastDayDate: function (day){
            return this.getPastDayDatetime(day).split(' ')[0];;
        },
        getFirstDatetimeOfMonth: function (day){
            let dt = this.strToDateObject(day);
            dt.setDate(1);
            return this.timeFormat(dt);
        },
        getFirstDayOfMonth: function (day){
            return this.getFirstDatetimeOfMonth(day).split(' ')[0];
        },
        getLastDatetimeOfMonth: function (day){
            let dt = this.strToDateObject(day);
            dt.setMonth(dt.getMonth() + 1);
            dt.setMinutes(-1);
            return this.timeFormat(dt);
        },
        getLastDayOfMonth: function (day){
            return this.getLastDatetimeOfMonth(day).split(' ')[0];
        },
        strToDateObject(day){
            if (day.length == 0) {
            	return new Date();
            }
            const a = day.split(' ');
            const ymd = a[0].split('/');
            let ret = new Date(ymd[0], ymd[1] - 1);
            if (ymd.length == 3) {
            	ret.setDate(ymd[2]);
            }
            if (a.length == 2) {
            	ret.setHours(...a[1].split(':'));
            }
            return ret;
        },
        culcSubDayFrom2DateObj(dateTo, dateFrom){
            return (dateTo - dateFrom) / 86400000;
        },
        culcSubDayFrom2DateStr(dateTo, dateFrom){
            return this.culcSubDayFrom2DateObj(this.strToDateObject(dateTo), this.strToDateObject(dateFrom));
        },
        timeFormat: function (date){
            var y = this.toDoubleDigits(date.getFullYear());
            var mm  = this.toDoubleDigits(date.getMonth() + 1);
            var d = this.toDoubleDigits(date.getDate());
            var h = this.toDoubleDigits(date.getHours());
            var m  = this.toDoubleDigits(date.getMinutes());
            return `${y}/${mm}/${d} ${h}:${m}`;
        },
        strTimeFormat: function (strDate){
            return this.timeFormat(this.strToDateObject(strDate));
        },
        getPastDay: function (date, day){
            var d = date;
            d.setDate(d.getDate() - day);
            return d;
        },
        getStrMonthFromStrDate: function (date){
            var d = this.strToDateObject(date);
            var y = this.toDoubleDigits(d.getFullYear());
            var mm  = this.toDoubleDigits(d.getMonth() + 1);            
            return `${y}/${mm}`;
        },
        toDoubleDigits: function(num){
            num += "";
            if (num.length === 1) {
              num = "0" + num;
            }
            return num;
        },
        isLaterLeftTime: function(leftTime, rightTime){
            let left = parseFloat(leftTime.replace(/[^0-9^\.]/g,""));
            let right = parseFloat(rightTime.replace(/[^0-9^\.]/g,""));
            return left >= right;
        }
    }
    inject('timeutil', timeutil);
}